"use client";
import type { ReactElement } from "react";
import { Cbutton } from "@/components/ui/Cbutton";
import { ButtonPreset } from "@/constants/componentPresets";
import { FontWeight } from "@/theme/typography";
import { AXIS_HEIGHT, HOVER_TRANSITION } from "./gantt-constants";
import { selectGanttLabelSectionRowModel } from "./gantt-label-row-selectors";
import type { GanttSectionRowLayout } from "./gantt-types";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
const CSS_INHERIT = "inherit";
export interface GanttLabelSectionRowProps {
    sectionRow: GanttSectionRowLayout;
    onToggleSection: (sectionIndex: number) => void;
}
export function GanttLabelSectionRow({ sectionRow, onToggleSection, }: GanttLabelSectionRowProps): ReactElement {
    const model = selectGanttLabelSectionRowModel({ sectionRow });
    return (
    <Cbutton rootAttributes={{ "data-el": "Cmarkdowngantt/LabelSectionRow/Trigger" }} preset={ButtonPreset.Ghost} ariaLabel={`Toggle ${model.sectionLabel}`} onClick={() => onToggleSection(sectionRow.sectionIndex)} padding={0} radius={0} disableClickMotion disableHoverEffects style={{
            position: "absolute",
            top: sectionRow.y - AXIS_HEIGHT,
            left: 0,
            width: "100%",
            height: sectionRow.height,
            cursor: "pointer",
        }} containerStyle={{
            width: "100%",
            height: "100%",
            backgroundImage: model.background,
            boxShadow: model.boxShadow,
            color: model.color,
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            padding: "0 10px 0 12px",
            textAlign: "left",
            transition: HOVER_TRANSITION,
        }} contentStyle={{
            justifyContent: "flex-start",
            gap: 6,
        }}>
      <span style={{
            color: "#66FEC1",
            fontSize: 10,
            width: 12,
            display: "inline-flex",
            justifyContent: "center",
            opacity: model.chevronOpacity,
            transform: model.chevronTransform,
            transition: "transform 160ms ease-out, opacity 160ms ease-out",
        }}>
        ▸
      </span>
      <CmarkdownLabelText dataElScope="Cmarkdowngantt/GanttLabelSectionRow" content={model.sectionLabel} size={11} weight={FontWeight.Bold} style={{ minWidth: 0, overflow: "hidden" }} paragraphStyle={{ marginBottom: 0, minWidth: 0 }} textStyle={{
            color: CSS_INHERIT,
            letterSpacing: CSS_INHERIT,
            textTransform: CSS_INHERIT,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }}/>
    </Cbutton>
    );
}
